/**
 * Trigger a browser download for an in-memory string. Used for CSV / GeoJSON
 * exports across the app. Identical to the helper that used to live in
 * `Layers.tsx` and `Coords.tsx`; this module is the single source.
 */
export function downloadFile(content: string, filename: string, mime = 'application/json'): void {
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
